/**
 * Katalog aller ein-/ausblendbaren Startfenster-Bereiche und -Kacheln.
 * Default: alles sichtbar (hidden = []).
 * Blöcke (order) und Kacheln (tileOrder) sind im Editiermodus verschiebbar.
 */

/** Verschiebbare Desktop-Blöcke (Willkommen bleibt fix oben). */
export const STARTFENSTER_BLOCKS = [
  { key: 'kpi_strip', label: 'Kennzahlen' },
  { key: 'alerts', label: 'Vorgangs-Karten' },
  { key: 'ops_grid', label: 'Vorgänge' },
  { key: 'filter_strip', label: 'Filterleiste' },
  { key: 'data_status', label: 'Datenstand je Mandant' },
  { key: 'sms_delivery', label: 'Probestunden / SMS-Erinnerungen' },
  { key: 'my_quicklinks', label: 'Meine Quicklinks' },
  { key: 'schnellzugriff', label: 'Schnellzugriff' },
  { key: 'data_quality', label: 'Datenqualität / Vertragsstatus' },
];

export const DEFAULT_BLOCK_ORDER = STARTFENSTER_BLOCKS.map((b) => b.key);

export const STARTFENSTER_GROUPS = [
  {
    id: 'board',
    title: 'Startboard',
    items: [
      { key: 'kpi_enrollments', label: 'KPI: Belegungen' },
      { key: 'kpi_courses', label: 'KPI: Kurse' },
      { key: 'kpi_prepaid', label: 'KPI: Prepaid-Karten' },
      { key: 'kpi_trials', label: 'KPI: P/S-Stunden' },
      { key: 'kpi_students', label: 'KPI: Schüler:innen' },
      { key: 'kpi_total', label: 'KPI: Gesamt' },
      { key: 'alert_trials', label: 'Probe-/Schnupperstunden' },
      { key: 'alert_registrations', label: 'Online-Anmeldungen (Karte)' },
      { key: 'alert_deregistrations', label: 'Online-Abmeldungen' },
      { key: 'alert_withdrawals', label: 'Online-Widerrufe' },
      { key: 'alert_messages', label: 'Nachrichten' },
      { key: 'alert_calendar', label: 'Kalender' },
      { key: 'ops_overdue', label: 'Vorgänge: Überfällig' },
      { key: 'ops_today', label: 'Vorgänge: Heute' },
      { key: 'ops_week', label: 'Vorgänge: Innerhalb von 7 Tagen' },
      { key: 'data_quality', label: 'Datenqualität / Vertragsstatus' },
    ],
  },
  {
    id: 'widgets',
    title: 'Widgets & Filter',
    items: [
      { key: 'filter_strip', label: 'Filterleiste (Nur Aktive / Aktiv ab)' },
      { key: 'data_status', label: 'Datenstand je Mandant' },
      { key: 'sms_delivery', label: 'Probestunden / SMS-Erinnerungen' },
      { key: 'my_quicklinks', label: 'Meine Quicklinks' },
    ],
  },
  {
    id: 'schnellzugriff_overview',
    title: 'Schnellzugriff: Übersicht & Kalender',
    section: 'overview',
    items: [
      { key: 'tile_unterrichtsverwaltung', label: 'Unterrichtsverwaltung' },
      { key: 'tile_kalender', label: 'Kalender' },
      { key: 'tile_heutige_termine', label: 'Heutige Termine' },
      { key: 'tile_anwesenheit', label: 'Anwesenheit' },
      { key: 'tile_reports', label: 'Reports' },
      { key: 'tile_suche', label: 'Suche' },
      { key: 'tile_app', label: 'App' },
    ],
  },
  {
    id: 'schnellzugriff_stammdaten',
    title: 'Schnellzugriff: Stammdaten',
    section: 'stammdaten',
    items: [
      { key: 'tile_schueler', label: 'Schüler' },
      { key: 'tile_lehrkraefte', label: 'Lehrkräfte' },
      { key: 'tile_kurse', label: 'Kurse' },
      { key: 'tile_standorte', label: 'Standorte' },
      { key: 'tile_raeume', label: 'Räume' },
      { key: 'tile_familien', label: 'Familien' },
    ],
  },
  {
    id: 'schnellzugriff_tarife',
    title: 'Schnellzugriff: Tarife & Belegung',
    section: 'tarife',
    items: [
      { key: 'tile_gebuehrenverwaltung', label: 'Gebührenverwaltung' },
      { key: 'tile_neue_belegung', label: 'Neue Belegung' },
    ],
  },
  {
    id: 'schnellzugriff_finanzen',
    title: 'Schnellzugriff: Abrechnung & Finanzen',
    section: 'finanzen',
    items: [
      { key: 'tile_rechnungen', label: 'Rechnungen' },
      { key: 'tile_rechnungslauf', label: 'Rechnungslauf' },
      { key: 'tile_sepa', label: 'SEPA-Lastschrift' },
      { key: 'tile_export_csv', label: 'Export CSV' },
      { key: 'tile_export_xlsx', label: 'Export XLSX' },
    ],
  },
  {
    id: 'schnellzugriff_import',
    title: 'Schnellzugriff: Datenimport',
    section: 'import',
    items: [
      { key: 'tile_msv_import', label: 'MSV Import' },
      { key: 'tile_import_konflikte', label: 'Import-Konflikte' },
    ],
  },
  {
    id: 'schnellzugriff_system',
    title: 'Schnellzugriff: System',
    section: 'system',
    items: [
      { key: 'tile_einstellungen', label: 'Einstellungen' },
      { key: 'tile_meine_funktionen', label: 'Meine Funktionen' },
    ],
  },
];

export const ALL_STARTFENSTER_KEYS = STARTFENSTER_GROUPS.flatMap((g) => g.items.map((i) => i.key));

export const ALL_TILE_KEYS = STARTFENSTER_GROUPS
  .filter((g) => g.id.startsWith('schnellzugriff_'))
  .flatMap((g) => g.items.map((i) => i.key));

export const DEFAULT_TILE_ORDER = [...ALL_TILE_KEYS];

export const TILE_SECTION_META = STARTFENSTER_GROUPS
  .filter((g) => g.section)
  .map((g) => ({
    id: g.section,
    title: g.title.replace(/^Schnellzugriff:\s*/i, ''),
    keys: g.items.map((i) => i.key),
  }));

export function storageKeyForUser(userId) {
  return `mamv.startfenster.${userId || 'anon'}`;
}

export function mergeOrder(saved, defaults) {
  const seen = new Set();
  const out = [];
  for (const k of saved || []) {
    if (defaults.includes(k) && !seen.has(k)) {
      out.push(k);
      seen.add(k);
    }
  }
  for (const k of defaults) {
    if (!seen.has(k)) out.push(k);
  }
  return pinBlockAfter(out, 'data_quality', 'schnellzugriff');
}

/** Datenqualität immer direkt unter den Schnellzugriff-Kacheln. */
export function pinBlockAfter(order, blockKey, afterKey) {
  const list = (order || []).filter((k) => k !== blockKey);
  if (!(order || []).includes(blockKey)) return list;
  const idx = list.indexOf(afterKey);
  if (idx < 0) return [...list, blockKey];
  const next = [...list];
  next.splice(idx + 1, 0, blockKey);
  return next;
}

export function moveItem(list, fromId, toId) {
  if (!fromId || !toId || fromId === toId) return list;
  const next = [...list];
  const from = next.indexOf(fromId);
  const to = next.indexOf(toId);
  if (from < 0 || to < 0) return list;
  next.splice(from, 1);
  next.splice(to, 0, fromId);
  return next;
}

export function emptyLayout() {
  return {
    hidden: [],
    order: [...DEFAULT_BLOCK_ORDER],
    tileOrder: [...DEFAULT_TILE_ORDER],
  };
}

export function readLocalLayout(userId) {
  try {
    const raw = JSON.parse(localStorage.getItem(storageKeyForUser(userId)) || 'null');
    if (!raw || typeof raw !== 'object') return emptyLayout();
    return {
      hidden: Array.isArray(raw.hidden) ? raw.hidden.filter(Boolean) : [],
      order: mergeOrder(raw.order, DEFAULT_BLOCK_ORDER),
      tileOrder: mergeOrder(raw.tileOrder, DEFAULT_TILE_ORDER),
    };
  } catch {
    return emptyLayout();
  }
}

export function writeLocalLayout(userId, layout) {
  try {
    localStorage.setItem(storageKeyForUser(userId), JSON.stringify({
      hidden: layout.hidden || [],
      order: layout.order || DEFAULT_BLOCK_ORDER,
      tileOrder: layout.tileOrder || DEFAULT_TILE_ORDER,
    }));
  } catch { /* ignore */ }
}

/** @deprecated use readLocalLayout */
export function readLocalHidden(userId) {
  return readLocalLayout(userId).hidden;
}

/** @deprecated use writeLocalLayout */
export function writeLocalHidden(userId, hidden) {
  const cur = readLocalLayout(userId);
  writeLocalLayout(userId, { ...cur, hidden });
}
